import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Button,
  Card,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListSubheader,
  Menu,
  MenuItem,
  Stack,
  Typography,
  Chip,
  Avatar
} from "@mui/material";
import { MoreVert as MoreIcon, Build as BuildIcon, Inventory2 as InventoryIcon } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { FETCH_COMPANIES_PRODUCTS, SAVE_COMPANY_PRODUCT } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import Loader from "../../common/Loader";
import { useNavigate } from "react-router-dom";
import { BIGrey, BIRed } from "../../assets/helpers";
import SearchField from "../common/SearchField";
import AddProductModal from "../common/AddProductModal";
import { useDispatch } from "react-redux";
import { setShowReport } from "../../redux/actions/actions";
import Emptydata from "../common/Emptydata";
import { English } from "../../constant/EnglishFallback";
import InfiniteScroll from "react-infinite-scroll-component";
import Pages from "../../constant/ReportModel";

// Tab label constant — exported so CompanyProfile can import it
export const USED_PRODUCTS_TAB_LABEL = "Used Products";

function CompanyProductSection({
  id,
  scrollId,
  currentCompanyName = "",
  currentCompanyAllowPublicProductSubmission = true
}) {
  const { loginData, multiLanguageData, reportSuccess } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const LanguageData = multiLanguageData?.Companies || {};
  const {
    TEXT_ADD_PRODUCT = English.Companies.TEXT_ADD_PRODUCT,
    TEXT_FOR_COMPANY_VIEW = English.Companies.TEXT_FOR_COMPANY_VIEW,
    TEXT_SEARCH_COMPANY_PRODUCTS = English.Companies.TEXT_SEARCH_COMPANY_PRODUCTS,
    BUTTON_REPORT = English.Companies.BUTTON_REPORT,
    TEXT_NO_DATA_INFO_SUBTEXT = English.Companies.TEXT_NO_DATA_INFO_SUBTEXT,
    TEXT_NO_INFO_COMPANY = English.Companies.TEXT_NO_INFO_COMPANY,
    TEXT_NO_RESULTS_FOUND = English.Companies.TEXT_NO_RESULTS_FOUND,
    TEXT_ADD_PRODUCT_TO_COMPANY = English.Companies.TEXT_ADD_PRODUCT_TO_COMPANY,
    NO_ROLE = English.Companies.NO_ROLE
  } = LanguageData || {};

  const debounceTimeout = useRef(null);
  const [productData, setProductData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showSearchLoader, setShowSearchLaoder] = useState(false);
  const [hasData, setHasData] = useState(false);
  const [showAddProductModal, setShowAddProductModal] = useState(false);
  const [product, setProduct] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [allDataLoaded, setAllDataLoaded] = useState(false);

  useEffect(() => {
    if (reportSuccess !== true) getInitialData();
  }, [reportSuccess]);

  const getInitialData = async () => {
    setIsLoading(true);
    await getProductData(searchTerm, 1, "fristTimeApiCall");
    setIsLoading(false);
  };

  const getProductData = async (searchTerm, pageNumber, fristTimeApiCall) => {
    try {
      setAllDataLoaded(true);
      const obj = {
        PageNr: pageNumber,
        NrOfRecPerPage: 20,
        FullSearch: searchTerm ?? "",
        SearchList: [{ companyId: id }],
        userId: currentUserId,
        IncludeRecordNr: true,
        SortList: [{}],
        FetchAllowedRecordsOnly: true,
        TypeOfObjectReturned: ""
      };

      const res = await Postrequestcall(FETCH_COMPANIES_PRODUCTS, obj, loginData?.accessToken);
      if (res.status === 200) {
        let resData =
          res?.data?.data?.sort((a, b) => a?.productName?.localeCompare(b?.productName)) ?? [];

        const groupedData = resData.reduce((acc, item) => {
          const key =
            item?.manufacturerId === 0 || item?.manufacturerName?.trim() === ""
              ? NO_ROLE
              : item?.manufacturerName;

          if (!acc[key]) {
            acc[key] = {
              manufacturerId: item?.manufacturerId,
              manufacturerName:
                item?.manufacturerId === 0 || item?.manufacturerName?.trim() === ""
                  ? NO_ROLE
                  : item?.manufacturerName,
              items: []
            };
          }
          acc[key].items.push(item);
          return acc;
        }, {});

        let groupData = Object.values(groupedData);
        const noRoleData = groupData.find((group) => group?.manufacturerName === NO_ROLE);
        if (noRoleData) {
          groupData = groupData.filter((group) => group?.manufacturerName !== NO_ROLE);
          groupData.push(noRoleData);
        }

        if (pageNumber > 1) {
          setTimeout(() => {
            setProductData((prevProducts) => [...prevProducts, ...groupData]);
          }, 500);
        } else {
          setProductData(() => groupData);
          if (fristTimeApiCall) {
            setHasData(groupData?.length > 0);
          }
        }
      }
    } catch (error) {
      console.log("getProductData-> Error Fetching Company Products: ", error);
    } finally {
      setShowSearchLaoder(false);
      setIsLoading(false);
      setAllDataLoaded(false);
    }
  };

  const handleOpenReportModal = () => {
    setMoreMenuAnchorEl(null);
    let reportObj = {
      showReport: true,
      recordId: product.productId ?? 0,
      name: Pages?.companiesProducts?.name,
      AppScreenId: Pages?.companiesProducts?.id
    };
    dispatch(setShowReport(reportObj));
  };

  const onAddProductClick = () => setShowAddProductModal(true);
  const onItemClick = (item) => navigate(`/product/${item?.productId}`);
  const onProductClick = (currentTarget, product) => {
    setProduct(product);
    setMoreMenuAnchorEl(currentTarget);
  };

  const increaseOffset = (callback) => {
    setPageNumber((prevPageNr) => prevPageNr + 1);
    callback(pageNumber + 1);
  };

  const saveProduct = async (productId) => {
    try {
      setIsLoading(true);
      const obj = {
        UserId: Number(currentUserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            ProductId: productId,
            CompanyId: id,
            ModifiedBy: Number(currentUserId),
            RecordStatusId: 1
          }
        ]
      };
      await Postrequestcall(SAVE_COMPANY_PRODUCT, obj, loginData?.accessToken);
      await getInitialData();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("saveProduct-> Error While Saving Product In Company: ", error);
    }
  };

  const NoInformation = () => (
    <Stack gap={1} sx={{ height: "100%" }}>
      <Button
        onClick={onAddProductClick}
        sx={{ alignSelf: "flex-end" }}
        variant="outlined"
        size="small"
        startIcon={<BuildIcon />}>
        {TEXT_ADD_PRODUCT}
      </Button>
      <Box className="empty-data-card">
        <Emptydata
          icon={<InventoryIcon className="emptydata-icon" />}
          firstText={TEXT_NO_INFO_COMPANY}
          secondText={TEXT_NO_DATA_INFO_SUBTEXT}
        />
      </Box>
    </Stack>
  );

  const renderListing = () => (
    <Box>
      <Stack gap={1}>
        {/* Section header */}
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 0.5 }}>
          <Stack direction="row" alignItems="center" gap={1}>
            <InventoryIcon sx={{ color: "text.secondary", fontSize: 18 }} />
            <Typography variant="body2" color="textSecondary" fontWeight={500}>
              {TEXT_FOR_COMPANY_VIEW}
            </Typography>
          </Stack>
          <Chip
            label={USED_PRODUCTS_TAB_LABEL}
            size="small"
            color="primary"
            variant="outlined"
            sx={{ fontSize: "0.7rem" }}
          />
        </Stack>

        <SearchField
          placeholder={TEXT_SEARCH_COMPANY_PRODUCTS}
          value={searchTerm}
          onChange={(value) => {
            setShowSearchLaoder(true);
            setSearchTerm(value);
            if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
            debounceTimeout.current = setTimeout(() => {
              getProductData(value, 1);
            }, 1000);
          }}
          onSubmit={() => {
            setShowSearchLaoder(true);
            getProductData(searchTerm, 1);
          }}
          size="small"
        />
        <Button
          variant="text"
          sx={{ alignSelf: "flex-end" }}
          size="small"
          startIcon={<BuildIcon />}
          onClick={onAddProductClick}>
          {TEXT_ADD_PRODUCT}
        </Button>
      </Stack>

      <Stack spacing={1} mt={1}>
        {showSearchLoader ? (
          <Stack style={{ padding: "30px" }}>
            <Loader />
          </Stack>
        ) : productData?.length > 0 ? (
          <InfiniteScroll
            dataLength={productData?.length}
            next={async () => {
              increaseOffset((pageNumber) => {
                getProductData(searchTerm, pageNumber);
              });
            }}
            hasMore={true}
            loader={
              !allDataLoaded ? null : (
                <h4 style={{ display: "flex", justifyContent: "center" }}>
                  <Loader />
                </h4>
              )
            }
            scrollableTarget={scrollId}>
            <List disablePadding>
              {productData.map((item) => (
                <Box key={item?.manufacturerId ?? item?.id}>
                  <ListSubheader
                    key={`subheader-${item?.manufacturerId}`}
                    sx={{
                      pl: 0.5,
                      cursor: item?.manufacturerId ? "pointer" : "default",
                      display: "flex",
                      alignItems: "center",
                      gap: 1
                    }}
                    onClick={() => {
                      item?.manufacturerId && navigate(`/manufacture/${item?.manufacturerId}`);
                    }}>
                    <Avatar
                      sx={{
                        width: 22,
                        height: 22,
                        fontSize: "0.65rem",
                        bgcolor: item?.manufacturerId ? "primary.main" : "grey.400"
                      }}>
                      {item?.manufacturerName?.[0] ?? "?"}
                    </Avatar>
                    <Typography
                      variant="caption"
                      fontWeight={700}
                      color={item?.manufacturerId ? "primary.main" : "text.secondary"}
                      sx={{ textDecoration: item?.manufacturerId ? "underline" : "none" }}>
                      {item?.manufacturerName}
                    </Typography>
                  </ListSubheader>

                  <Stack spacing={0.8} sx={{ mb: 1 }}>
                    {item?.items?.map((product) => (
                      <Card
                        key={product?.id ?? `${product?.productName}-${Math.random()}`}
                        className="pagelist-content"
                        sx={{
                          transition: "all 0.18s",
                          "&:hover": { boxShadow: "0 2px 12px rgba(0,0,0,0.1)", transform: "translateY(-1px)" }
                        }}>
                        <ListItem
                          style={{ padding: "0px" }}
                          secondaryAction={
                            <IconButton
                              size="small"
                              onClick={(event) => onProductClick(event.currentTarget, product)}>
                              <MoreIcon fontSize="small" />
                            </IconButton>
                          }>
                          <ListItemButton onClick={() => onItemClick(product)}>
                            <ListItemText
                              primary={
                                <Typography variant="body2" fontWeight={500}>
                                  {product?.productName}
                                </Typography>
                              }
                            />
                          </ListItemButton>
                        </ListItem>
                      </Card>
                    ))}
                  </Stack>
                </Box>
              ))}
            </List>
            <Menu
              anchorEl={moreMenuAnchorEl}
              open={Boolean(moreMenuAnchorEl)}
              onClose={() => setMoreMenuAnchorEl(null)}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}>
              <MenuItem onClick={() => handleOpenReportModal()} style={{ color: BIRed }} dense>
                {BUTTON_REPORT}
              </MenuItem>
            </Menu>
          </InfiniteScroll>
        ) : (
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            style={{ color: BIGrey, padding: "30px" }}>
            {TEXT_NO_RESULTS_FOUND}
          </Stack>
        )}
      </Stack>
    </Box>
  );

  return (
    <Box className="main-content-card-list">
      <Card className="pagelist-content" sx={{ p: 2 }}>
        {isLoading ? <Loader /> : hasData ? renderListing() : <NoInformation />}
        {showAddProductModal && (
          <AddProductModal
            open={showAddProductModal}
            onClose={() => setShowAddProductModal(false)}
            from="company"
            mainId={id}
            title={TEXT_ADD_PRODUCT_TO_COMPANY}
            currentCompanyName={currentCompanyName}
            currentCompanyAllowPublicProductSubmission={currentCompanyAllowPublicProductSubmission}
            skipCompanyProductSave={true}
            onProductCreated={async ({ productId, manufacturerId }) => {
              if (Number(manufacturerId) === Number(id)) {
                navigate(`/manufacture/${id}`);
                return;
              }
              await saveProduct(productId ?? 0);
            }}
            saveProduct={saveProduct}
          />
        )}
      </Card>
    </Box>
  );
}

export default CompanyProductSection;
